/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberSquareThree(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM149.457,177.45654a35.9963,35.9963,0,0,1-50.90723,0,8.00018,8.00018,0,0,1,11.31446-11.31347,19.99683,19.99683,0,1,0,14.13965-34.13868,7.99971,7.99971,0,0,1-6.55469-12.58642L136.63281,92H104a8,8,0,0,1,0-16h47.99414a7.99973,7.99973,0,0,1,6.55469,12.58643L137.5332,118.62305A36.01783,36.01783,0,0,1,149.457,177.45654Z" />
    </Svg>
  );
}

export default NumberSquareThree;
